import { createFileRoute } from "@tanstack/react-router";
import CreateListingAI from "@/pages/dashboard/CreateListingAI";
import SubscribedRoute from "@/components/shared/SubscribedRoute";

export const Route = createFileRoute("/dashboard/create-listing-ai/")({
  head: () => ({
    meta: [
      { title: "Creează anunț din video cu AI | RO Auto Market" },
      {
        name: "description",
        content:
          "Încarcă un videoclip cu mașina, iar AI pregătește fotografiile și informațiile pentru anunț.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Creează anunț din video cu AI" },
      {
        property: "og:description",
        content: "AI pregătește fotografiile și datele anunțului dintr-un singur videoclip.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute>
      <CreateListingAI />
    </SubscribedRoute>
  );
}
